export default __webpack_public_path__ + "static/media/icons8-timesheet.d57328f0.svg";